import { SnCamera, SnCameraStatus } from '@lib/api/entities';
import { GoogleMapMarker, GoogleMapMarkerType, GoogleMapPopup } from '@lib/geo/google/map';
import { COLORS } from '@lib/ui/theme';

export class SnCameraMarker extends GoogleMapMarker {
  public infoWindow: GoogleMapPopup;

  constructor(public readonly camera: SnCamera) {
    super({
      id: `camera-${camera.id}`,
      type: GoogleMapMarkerType.CIRCLE,
      lonLat: camera.geometry.coordinates,
      title: camera.name,
    });

    this.setStyle({
      scale: camera.isAiEnabled ? 1.2 : 1,
      strokeOpacity: 0,
      fillOpacity: 0,
      rotation: camera.heading ? camera.heading : 90,
    });
    this.setIcon(this._getIcon());
  }

  public setScale(scale: number): void {
    const style = this.style;

    this.setStyle({ ...style, scale });
  }

  private _getIcon(): string {
    const icon: any = {
      fontSet: 'fs',
    };
    let status = 'Exists';
    const ptz = this.camera.type === 'PTZ';
    if (this.camera.isParentCamera) {
      icon.fontIcon = 'quad_camera_lite';
      icon.color =
        this.camera.status === SnCameraStatus.Up
          ? '#67BD4D'
          : this.camera.status === SnCameraStatus.Down
          ? ' #FF3535'
          : this.camera.status === SnCameraStatus.Unmanaged
          ? '#FFB028'
          : 'rgb(137, 137, 137);';
      this.setStyle({
        strokeOpacity: 1,
        fillOpacity: 1,
        fillColor: COLORS['base-800'],
        strokeColor: COLORS['grey-400'],
        strokeWeight: 1,
        rotation: 0,
        scale: 1.4,
      });
      this.setBadge({
        value: this.camera.descendantCount + 1,
        color: 'secondary',
        positionX: 'after',
        positionY: 'below',
      });
      return icon;
    }
    switch (this.camera.status) {
      case SnCameraStatus.Up:
        status = 'Up';
        break;
      case SnCameraStatus.Down:
        status = 'Down';
        break;
      case SnCameraStatus.Unmanaged:
        icon.fontIcon = 'CameraUnmanaged';
        return icon;
    }
    if (ptz) {
      icon.fontIcon = this.camera.isAiEnabled ? `Camera${status}_AI_PTZ` : `Camera${status}_PTZ`;
      return icon;
    }
    icon.fontIcon = this.camera.isAiEnabled ? `Camera${status}_AI` : `Icon_Camera${status}`;
    return icon;
  }
}
